import React from 'react';
import {connect} from 'react-redux';
import PlayersInfo from 'desktop/elements/players/info';
import {BasePlayersList} from 'components/organisms/players-list';
import PlayerInjury from 'components/molecules/player-injury';
import PlayerLock from 'components/molecules/player-lock';
import PlayerExclusionState from 'components/molecules/player-exclusion/player-exclusion-state';
import PlayerLineGroup from 'components/molecules/player-line-group';
import PlayerPPLine from 'components/molecules/player-PP-line';
import TeamLogo from 'components/molecules/team-logo';
import Loader from 'components/atoms/loaders/loader';

class PlayersList extends BasePlayersList {
    constructor(props) {
        super(props);
        this.state = this.getBaseState({
            sortBy: {
                col: 'rosterPosition',
                direction: 'asc',
            },
        });
    }

    componentDidUpdate(prevProps) {
        const {
            userPointsType,
            reset: {settings: resetSettings},
        } = this.props;
        const {userPointsType: prevUPType} = prevProps;

        if (this.wasSettingsReset(resetSettings)) {
            this.updateResetSettingsSignature(resetSettings);
            super.resetBaseState({
                sortBy: {
                    col: 'rosterPosition',
                    direction: 'asc',
                },
            });
        } else if (!userPointsType.isUserPointsTypeEqual(prevUPType.getUserPointsType())) {
            super.resetBaseState({
                sortBy: {...this.state.sortBy},
            });
        }
    }

    getSearchConditions() {
        const {playersFilter} = this.props;
        let ruleByLineGroup = {};
        if (this.isNotExcludedMode(playersFilter.playersType)) {
            ruleByLineGroup = this.getSearchRuleByLineGroup();
        }

        return {
            ...this.getSearchRuleByMode({
                overallMode: {
                    checkPointsExclusion: true,
                    // checkSalaryExclusion: true,
                },
            }),
            ...this.getSearchRuleByPosition(),
            ...this.getSearchRuleByPlayerName(),
            ...this.getSearchRuleByTeamName(),
            ...this.getSearchRuleByTiers(),
            ...ruleByLineGroup,
        };
    }

    render() {
        const {players, playersFilter} = this.props;

        if (!players.isPlayersGroupReady()) {
            return <Loader />;
        }

        const playersList = this.getPlayersForRendering();
        const renderKey = this.getRenderKey();

        const rows = [];
        if (playersList.length > 0) {
            playersList.map((player, index) => {
                rows.push(
                    <tr key={index}>
                        <td className="td-chk">
                            <PlayerExclusionState activeMode={playersFilter.playersType} playerId={player.getId()} />
                        </td>
                        <td className="td-lock">
                            <PlayerLock className={`lock-btn`} playerId={player.getId()} />
                        </td>
                        <td>
                            <span>{`${player.name}`}</span>
                            <PlayerInjury player={player} />
                        </td>
                        <td>{this.getPlayerSympathyComponent({player, mode: playersFilter.playersType})}</td>
                        <td className={`tier tier-${player.rosterPositionName}`}>
                            <span>{player.rosterPositionName}</span>
                        </td>
                        <td>
                            <span>{player.positionName}</span>
                        </td>
                        <td className="td-team">
                            <TeamLogo teamName={player.team} />
                        </td>
                        <td className="td-vs">{this.getOpponentsDelimiter(player)}</td>
                        <td className="td-team">
                            <TeamLogo teamName={player.opponent} />
                        </td>
                        <td>
                            <span>{player.moneyLine}</span>
                        </td>
                        <td>
                            <PlayerLineGroup
                                className="form-control small-table-input"
                                playerId={player.getId()}
                                propName={'userLineGroup'}
                            />
                        </td>
                        <td>
                            <PlayerPPLine
                                className="form-control small-table-input"
                                playerId={player.getId()}
                                propName={'userPpLine'}
                            />
                        </td>
                        <td>
                            <span>{player.adminPoints}</span>
                        </td>
                        {this.getFinalPointsBlock({
                            points: player.fantasyPoints,
                        })}
                        <td className="td-narrow">
                            {this.wrapContentInTooltip(
                                this.getPlayerPointsComponent({
                                    player,
                                }),
                                `Default Score: ${player.adminPoints}`,
                            )}
                        </td>
                        <td className="td-narrow">
                            {this.getPlayerExposureComponent({
                                playerId: player.getId(),
                                propName: 'exposureMin',
                            })}
                        </td>
                        <td className="td-narrow">
                            {this.getPlayerExposureComponent({
                                playerId: player.getId(),
                                propName: 'exposureMax',
                            })}
                        </td>
                    </tr>,
                );
            });
        } else {
            rows.push(
                <tr key="players-not-found">
                    <td colSpan="18" className="text-center">
                        Players were not found.
                    </td>
                </tr>,
            );
        }

        return (
            <div>
                <div className="main-table table-holder table-scroll">
                    <table className="table players-pool">
                        <thead>
                            <tr>
                                <th className="td-chk">
                                    {this.getPlayersGroupExclusionSwitcherComponent(playersList)}
                                </th>
                                <th colSpan="3">
                                    <a
                                        className={super.getSortDirectionClassName('name')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'name')}
                                    >
                                        Name
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('rosterPosition')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'rosterPosition')}
                                    >
                                        Tier
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('position')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'position')}
                                    >
                                        Pos
                                    </a>
                                </th>
                                <th className="td-team">
                                    <a
                                        className={super.getSortDirectionClassName('team')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'team')}
                                    >
                                        Team
                                    </a>
                                </th>
                                <th className="td-vs"></th>
                                <th className="td-team">
                                    <a
                                        className={super.getSortDirectionClassName('opponent')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'opponent')}
                                    >
                                        Opp
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('moneyLine')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'moneyLine')}
                                    >
                                        Money Line
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('userLineGroup')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'userLineGroup')}
                                    >
                                        Line Group
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('userPpLine')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'userPpLine')}
                                    >
                                        PP Line
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('adminPoints')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'adminPoints')}
                                    >
                                        Proj
                                    </a>
                                </th>
                                {this.getFinalPointsHeaderSort()}
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('userPoints')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'userPoints')}
                                    >
                                        FPts
                                    </a>
                                </th>
                                <th className="td-per">
                                    <a
                                        className={super.getSortDirectionClassName('exposureMin')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'exposureMin')}
                                    >
                                        Exp. min
                                    </a>
                                    {this.getGeneralExposureComponent({
                                        players: playersList,
                                        propName: 'exposureMin',
                                    })}
                                </th>
                                <th className="td-per">
                                    <a
                                        className={super.getSortDirectionClassName('exposureMax')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'exposureMax')}
                                    >
                                        Exp. max
                                    </a>
                                    {this.getGeneralExposureComponent({
                                        players: playersList,
                                        propName: 'exposureMax',
                                    })}
                                </th>
                            </tr>
                        </thead>

                        <tbody>{rows}</tbody>
                    </table>
                </div>

                <PlayersInfo playersQuantity={playersList.length} />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        reset,
        playersLock,
        userPointsType,
        modesConfig,
        playersData: {
            players,
            filters,
            tiersFilter,
            lineGroupFilter,
        },
    } = state;

    return {
        players,
        playersFilter: filters,
        playersLock,
        sportConfig,
        tiersFilter,
        lineGroupFilter,
        reset,
        userPointsType,
        modesConfig,
    };
}

const Table = connect(mapStatesToProps)(PlayersList);

export {Table};
